import React from 'react';
import { observer } from 'mobx-react';

import { tooltipOptions } from './constants';
import { AntSelectWithCustomOptions } from 'controls/react/AntSelectWithCustomOptions';
import { AntSelectProps } from 'controls/react/ant/ant-select/types';

export type MetricTooltipSelectProps = AntSelectProps<string[]> & {};

export const MetricTooltipSelect = observer((props: MetricTooltipSelectProps) => {
	return <AntSelectWithCustomOptions {...props} options={tooltipOptions} />;
});
